module.exports = __webpack_public_path__ + "files/f8d541f5bbebfa291bd4d01e63176890.png";